import React from 'react'
import { connect } from 'react-redux'
import algoliasearch from 'algoliasearch'
import { selectors as ConfigSelectors } from 'data/config'

export default function(renderPlaceholder = () => null) {
  return function fetchesSearchToken(OriginalComponent) {
    return connect(state => ({
      searchApplicationId: ConfigSelectors.getSearchApplicationId(state),
      searchToken: ConfigSelectors.getSearchToken(state),
    }))(({ searchApplicationId, searchToken, ...props }) => {
      if (!searchApplicationId || !searchToken) {
        return renderPlaceholder()
      }
      const algoliaClient = algoliasearch(searchApplicationId, searchToken)
      return <OriginalComponent algoliaClient={algoliaClient} {...props} />
    })
  }
}
